import { FunctionComponent, h } from 'preact'
import { useState } from 'preact/hooks'
import { Button, Textarea } from 'components/ui'

import { Field, FieldEntry, TextArea as TextAreaFieldType, TextareaFieldValue } from 'scripts/type'

import classes from './textarea.module.scss'
import cn from 'classnames'

type Props = {
  field: Field
  visible: boolean
  onSubmit?: (fieldEntry: FieldEntry) => void
}

const TextareaField: FunctionComponent<Props> = ({ field, visible, onSubmit }) => {
  const { code, screenshotsEnabled } = field as TextAreaFieldType
  const [disableSubmit, setDisableSubmit] = useState(false)
  const [value, setValue] = useState<TextareaFieldValue>({ text: '', screenshots: [] })

  const handleSubmit = () => {
    onSubmit?.({
      code: field.code,
      value,
    })
  }

  return (
    <div className={cn(classes.textareaField, visible && classes.show)}>
      <Textarea
        withBorder={true}
        fieldCode={code}
        placeholder="您还有什么想要告诉我们或补充的？"
        screenshotsEnabled={screenshotsEnabled}
        onChange={(value) => setValue(value)}
        onUploadStart={() => setDisableSubmit(true)}
        onUploadEnd={() => setDisableSubmit(false)}
        className="h-[80px]"
      />
      <Button onClick={handleSubmit} disabled={disableSubmit} fullWidth={false}>
        提交并关闭
      </Button>
    </div>
  )
}

export default TextareaField
